import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Header from './header';
import { getAISummaryTemplate, setAISummaryTemplate, DEFAULT_AI_SUMMARY_TEMPLATE } from '../services/firestore';

function AISummaryTemplate() {
  const [template, setTemplate] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const saved = await getAISummaryTemplate();
      setTemplate(saved || DEFAULT_AI_SUMMARY_TEMPLATE);
      setLoading(false);
    };
    load();
  }, []);

  const handleSave = async () => {
    if (!template.trim()) {
      toast.error('Template cannot be empty', { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    setSaving(true);
    try {
      await setAISummaryTemplate(template);
      toast.success('Summary template saved!', { position: toast.POSITION.TOP_RIGHT });
    } catch (e) {
      toast.error('Failed to save template.', { position: toast.POSITION.TOP_RIGHT });
    }
    setSaving(false);
  };

  const handleReset = () => {
    setTemplate(DEFAULT_AI_SUMMARY_TEMPLATE);
    toast.info('Reset to default. Click Save to apply.', { position: toast.POSITION.TOP_RIGHT });
  };

  return (
    <div>
      <div className='container-fluid p-0 bgInnerDiv'>
        <Header />
        <div className='container-fluid p-0 contentBody'>
          <div className='loginBoxDiv ForgotPassswordMain UserProfileMain whiteBgColor centerDivAlign'>
            <h2>Consultant Summary Template</h2>
            <p style={{ color: '#888', fontSize: '14px', marginBottom: '24px' }}>
              This template defines the sections used when generating Consultant Summary reports.
            </p>

            {loading ? (
              <p>Loading...</p>
            ) : (
              <div style={{ width: '100%' }}>
                <label style={{ fontWeight: '700', display: 'block', marginBottom: '8px' }}>Template:</label>
                <textarea
                  value={template}
                  onChange={(e) => setTemplate(e.target.value)}
                  rows={20}
                  style={{
                    width: '100%', padding: '12px', border: '1px solid #ddd',
                    borderRadius: '8px', fontSize: '13px', fontFamily: 'monospace',
                    lineHeight: '1.6', outline: 'none', resize: 'vertical', marginBottom: '16px',
                  }}
                />
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button
                    type="button"
                    onClick={handleSave}
                    disabled={saving}
                    style={{
                      padding: '8px 20px', background: '#024C9C', color: '#fff',
                      border: 'none', borderRadius: '8px', fontSize: '14px',
                      fontWeight: '600', cursor: saving ? 'not-allowed' : 'pointer',
                      opacity: saving ? 0.6 : 1, height: '38px',
                    }}
                  >
                    {saving ? 'Saving...' : 'Save Template'}
                  </button>
                  <button
                    type="button"
                    onClick={handleReset}
                    style={{
                      padding: '8px 20px', border: '1px solid #ccc', borderRadius: '8px',
                      background: '#fff', color: '#555', cursor: 'pointer',
                      fontSize: '14px', fontWeight: '500', height: '38px',
                    }}
                  >
                    Reset to Default
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AISummaryTemplate;
